import React, { useState } from "react";
import { getAPI, postAPI } from "../../../helpers/httpHelper";
import { cognitoUserToken } from "../../../helpers/userHelper";
import { URL_SUPPORT, ROW_COUNT, API_ADMIN_TIPO_UNIDAD_AUDITAR, API_ADMIN_TIPO_AUDITORIA } from "../../../helpers/variableHelper";
import { usePromiseEffect } from "../../../helpers/promiseEffect";
import AdminLista from "../AdminLista";
import { ITipoAuditoria } from "../../../entities/ITipoAuditoria";
import { ITipoUnidadAuditar } from "../../../entities/ITipoUnidadAuditar";
import { cParamsActiveOrderNombre } from "../../../helpers/paramsHelper";

interface ITipoUnidadAuditarProps {
  cbTipoAuditoria?: Array<ITipoAuditoria>;
}

const TipoUnidadAuditar = ({ cbTipoAuditoria }: ITipoUnidadAuditarProps) => {
  const userInfo = cognitoUserToken();
  const [token, setToken] = useState("");
  const [listItems, setListItems] = useState<Array<any>>([]);
  const [comboTA, setComboTA] = useState<Array<ITipoAuditoria>>(cbTipoAuditoria || []);
  const [isLoading, setIsLoading] = useState(false);
  const [pages, setPages] = useState(0);
  const [page, setPage] = useState(1);
  const [pageSize, setPageSize] = useState(ROW_COUNT);
  usePromiseEffect(async () => {
    setIsLoading(true);
    let token = await userInfo;
    setToken(token);

    let params = { PAGINA: 1, PAGINADO: pageSize, ORDENADOPOR: "ID", ORIENTACION: "DESC" };
    let result = (await getAPI(`${URL_SUPPORT}${API_ADMIN_TIPO_UNIDAD_AUDITAR}/getall`, { Authorization: `Bearer ${token}` }, params)).result;
    let list = result.data;
    let pages = result.pages;
    setPages(pages);
    setListItems(list);
    params.PAGINADO = ROW_COUNT;
    const combo = (await getAPI(`${URL_SUPPORT}${API_ADMIN_TIPO_AUDITORIA}/getall`, { Authorization: `Bearer ${token}` }, cParamsActiveOrderNombre))
      .result.data;
    setComboTA(combo);
    setIsLoading(false);
  }, [token]);
  const paging = (page: any) => {
    setPage(page);
    let params = { PAGINA: page };
    filter(params, true);
  };
  const filter = (filter: Partial<ITipoUnidadAuditar>, havePage: boolean = false, size = pageSize) => {
    if (!filter) {
      filter = {};
      filter.PAGINA = 1;
    }
    filter.TIPO_AUDITORIA = filter.ID_TIPO_AUDITORIA?.toString() || "";
    filter.PAGINADO = size;
    if (filter.PAGINA === undefined) {
      filter.PAGINA = page ?? 1;
    }
    if (!havePage && filter.PAGINA === undefined) {
      filter.PAGINA = page ?? 1;
    }
    setPage(filter.PAGINA);
    if (filter.ORDENADOPOR === undefined) {
      filter.ORDENADOPOR = "ID";
      filter.ORIENTACION = "DESC";
    }
    getAPI(`${URL_SUPPORT}${API_ADMIN_TIPO_UNIDAD_AUDITAR}/getall`, { Authorization: `Bearer ${token}` }, filter)
      .then((result) => {
        setListItems(result.result.data);
        let pages = result.result.pages;
        setPages(pages);
        setIsLoading(false);
      })
      .catch((error) => {});
  };
  const edit = (value: ITipoUnidadAuditar, filters: any) => {
    delete value.FECHA_CREACION;
    delete value.TRANSACTION_ID;
    if (value.ID === "") {
      delete value.ID;
    }

    postAPI(`${URL_SUPPORT}${API_ADMIN_TIPO_UNIDAD_AUDITAR}`, value, { Authorization: `Bearer ${token}` })
      .then((result) => {
        let data = result.result.data;
        console.log(data);

        filter(filters, value?.ID !== undefined);
      })
      .catch((error) => {
        console.log(error);
      });
  };

  return (
    <>
      {" "}
      <button
        data-testid="btnedit"
        hidden={true}
        onClick={() => {
          edit(
            {
              ID: "",
              NOMBRE: "string",
              ACTIVO: false,
              ID_TIPO_AUDITORIA: 1,
              TIPO_AUDITORIA: "string",
              AUTOR: "string",
              EDITOR: "string",
              FECHA_MODIFICACION: new Date(),
              ORDENADOPOR: "",
              ORIENTACION: "",
              PAGINA: 1,
              PAGINADO: 10,
            },
            {}
          );
          paging(1);
          filter(false as unknown as Partial<ITipoUnidadAuditar>, false, 1);
        }}></button>
      <AdminLista
        items={[
          {
            type: "ID_TIPO_AUDITORIA",
            value: comboTA.map((ta) => {
              return { text: ta.NOMBRE, value: ta.ID };
            }),
          },
        ]}
        reload={filter}
        callback={edit}
        data={listItems}
        tipo={"TipoUnidadAuditar"}
        filter={filter}
        pagination={{ pages: pages, page: page, paging: paging }}
        title="Ámbito de Auditoría"
        callbackUpdatePageSize={(pageSize: number, filters: Object) => {
          setPageSize(pageSize);
          filter(filters, false, pageSize);
        }}
        isLoading={isLoading}
      />
    </>
  );
};

export default TipoUnidadAuditar;
